import { render, staticRenderFns } from "./home-config.vue?vue&type=template&id=34003ca6&scoped=true"
var script = {}
import style0 from "./home-config.vue?vue&type=style&index=0&id=34003ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34003ca6",
  null
  
)

export default component.exports